/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';

/**
 * 
 * @export
 * @interface AdvertisingFormatDailyRowData
 */
export interface AdvertisingFormatDailyRowData {
    /**
     * 
     * @type {Date}
     * @memberof AdvertisingFormatDailyRowData
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingFormatDailyRowData
     */
    type?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatDailyRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatDailyRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatDailyRowData
     */
    impressions?: number;
    /**
     * 
     * @type {AdvertisingFormatDailyRowDataFinanceScopeEnum}
     * @memberof AdvertisingFormatDailyRowData
     */
    financeScope?: AdvertisingFormatDailyRowDataFinanceScopeEnum;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof AdvertisingFormatDailyRowData
     */
    mediaSourceQuality?: MediaSourceQuality;
}


/**
 * @export
 */
export const AdvertisingFormatDailyRowDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type AdvertisingFormatDailyRowDataFinanceScopeEnum = typeof AdvertisingFormatDailyRowDataFinanceScopeEnum[keyof typeof AdvertisingFormatDailyRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the AdvertisingFormatDailyRowData interface.
 */
export function instanceOfAdvertisingFormatDailyRowData(value: object): value is AdvertisingFormatDailyRowData {
    return true;
}

export function AdvertisingFormatDailyRowDataFromJSON(json: any): AdvertisingFormatDailyRowData {
    return AdvertisingFormatDailyRowDataFromJSONTyped(json, false);
}

export function AdvertisingFormatDailyRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingFormatDailyRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'type': json['type'] == null ? undefined : json['type'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
    };
}

export function AdvertisingFormatDailyRowDataToJSON(json: any): AdvertisingFormatDailyRowData {
    return AdvertisingFormatDailyRowDataToJSONTyped(json, false);
}

export function AdvertisingFormatDailyRowDataToJSONTyped(value?: AdvertisingFormatDailyRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'type': value['type'],
        'spend': MoneyOutputToJSON(value['spend']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'financeScope': value['financeScope'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
    };
}

